import ParticleBackground from "./ParticleBackground";
import { PROFILE_IMAGE } from "../config";

export default function Hero({ t, scrollY }) {
  return (
    <section id="hero" className="hero" data-testid="hero-section">
      <ParticleBackground />
      <div className="hero-content">
        <div className="hero-grid">
          <div className="hero-text-col fade-in">
            <div className="hero-eyebrow">{t.heroEye}</div>
            <h1 className="hero-title">
              <span className="hero-un">UN</span>DRIVE<sup className="hero-triangle-wrap" aria-hidden="true"><svg className="hero-triangle" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0L28 0L28 28Z" fill="#E8952A"/></svg></sup><sup className="trademark" aria-hidden="true">®</sup>
            </h1>
            <p className="hero-subtitle">{t.heroSub}</p>
            <p className="hero-description">{t.heroText}</p>
            <div className="cta-group">
              <a href="#kontakt" className="btn-primary" data-testid="cta-primary">
                {t.ctaPrimary}
              </a>
              <a href="#leistungen" className="btn-secondary" data-testid="cta-secondary">
                {t.ctaSecondary}
              </a>
            </div>
          </div>
          <div className="hero-image-col fade-in" style={{ transitionDelay: "0.2s" }}>
            <div
              className="photo-container"
              style={{ transform: `translateY(${scrollY * 0.1}px)` }}
            >
              <div className="photo-ring-outer" aria-hidden="true" style={{ transform: `rotate(${scrollY * 0.05}deg)` }} />
              <div className="photo-ring-inner" aria-hidden="true" style={{ transform: `rotate(${-scrollY * 0.08}deg)` }} />
              <div className="photo-ring-pulse" aria-hidden="true" />
              <img src={PROFILE_IMAGE} alt="Dominik Mietke – Gründer von UNDRIVE" className="profile-photo" width="280" height="280" fetchPriority="high" />
              <div className="photo-glow" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
